import React from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";
import CustomInput from "../custom/CustomInput";

const TestForm = () => {
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const payload = {
      name: values.name,
      email_id: values.email_id,
      mobile_no: values.mobile_no,
      remark: values.remark,
    };

    axios
      .post("https://ajivasanmusicacademy.com/ajivasan-backend/public/api/v1/test-form", payload)
      .then((res) => {
        // Swal.fire({
        //   position: "success",
        //   icon: "success",
        //   title: "Data sent successfully",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
        resetForm();
        // After successful API call, redirect to the PayU link
        window.location.href = "https://u.payu.in/UrQ7I841GAep";
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        setSubmitting(false);
      });
  };

  return (
    <React.Fragment>
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={6}>
            <Card>
              <CardBody>
                <h4 className="text-center mb-4">Test Form</h4>
                <Formik
                  initialValues={{
                    name: "",
                    email_id: "",
                    mobile_no: "",
                    remark: "",
                  }}
                  onSubmit={handleSubmit}
                  validationSchema={Yup.object().shape({
                    name: Yup.string().required("Name is required"),
                    email_id: Yup.string()
                      .required("Email is required")
                      .email("Invalid email address"),
                    mobile_no: Yup.string()
                      .required("Mobile number is required")
                      .matches(/^[0-9]+$/, "Must be only digits")
                      .min(10, "Must be exactly 10 digits")
                      .max(10, "Must be exactly 10 digits"),
                    remark: Yup.string("Batch Details is required"),
                  })}
                >
                  {(formProps) => (
                    <Form>
                      <Row className="form-group mb-3">
                        <Col md={12}>
                          <Label htmlFor="name">Name:</Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="name"
                              id="name"
                              placeholder="Enter Name"
                              className={
                                "form-control" +
                                (formProps.errors.name && formProps.touched.name
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mb-3">
                        <Col md={12}>
                          <Label htmlFor="email_id">Email ID:</Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="email_id"
                              id="email_id"
                              placeholder="Enter Email"
                              className={
                                "form-control" +
                                (formProps.errors.email_id && formProps.touched.email_id
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="email_id"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mb-3">
                        <Col md={12}>
                          <Label htmlFor="mobile_no">Mobile No:</Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="mobile_no"
                              id="mobile_no"
                              placeholder="Enter Mobile No"
                              className={
                                "form-control" +
                                (formProps.errors.mobile_no && formProps.touched.mobile_no
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="mobile_no"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mb-3">
                        <Col md={12}>
                          <Label htmlFor="remark">Batch Details:</Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="remark"
                              id="remark"
                              placeholder="Enter Batch Details"
                              className={
                                "form-control" +
                                (formProps.errors.remark && formProps.touched.remark
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="remark"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <div className="text-center mt-4">
                        <div>
                          <a
                            style={{
                              width: "150px",
                              backgroundColor: "#b81111",
                              textAlign: "center",
                              fontWeight: "800",
                              padding: "11px 0px",
                              color: "white",
                              fontSize: "12px",
                              display: "inline-block",
                              textDecoration: "none",
                              borderRadius: "3.229px",
                              cursor: formProps.isSubmitting ? "not-allowed" : "pointer",
                              opacity: formProps.isSubmitting ? 0.7 : 1,
                            }}
                            href="https://u.payu.in/UrQ7I841GAep"
                            onClick={(e) => {
                              e.preventDefault();
                              if (!formProps.isSubmitting) {
                                formProps.submitForm();
                              }
                            }}
                          >
                            {formProps.isSubmitting ? "Sending..." : "Pay Now"}
                          </a>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default TestForm;
